/**
 * Url helper class
 */
export class Url {

    private paramMap = new Map<string, string>(null);

    private readonly href: string;

    public constructor(href: string) {
        const urlParams = this.extractParamsFrom(href);

        if (urlParams !== undefined) {
            urlParams.map((value: string) => value.split('='))
                .forEach(([key, value]: string[]) => this.paramMap.set(key, value));
        }

        this.href = this.removeParamsFrom(href);
    }

    /**
     * Returns composed href string with set parameters
     */
    public getHref(): string {
        let params: string = '';

        this.paramMap.forEach((value: string, key: string) => {
            const insertion = `${key}=${value}`;
            params = params === '' ? insertion : `${params}&${insertion}`;
        });

        return params !== '' ? `${this.href}?${params}` : this.href;
    }

    /**
     * Returns parameter with provided key
     */
    public getSearchParam(name: string): string | undefined {
        return this.paramMap.get(name);
    }

    /**
     * Sets parameter with provided key and value
     */
    public addSearchParam(name: string, value: string): Url {
        this.paramMap.set(name, value);

        return this;
    }

    /**
     * Removes parameter with provided key
     */
    public removeSearchParam(name: string): Url {
        const isSuccesful = this.paramMap.delete(name);

        if (!isSuccesful) {
            console.info(`Search parameter: ${name} was not present in search params map.`);
        }

        return this;
    }

    /**
     * Returns url without query params
     */
    private removeParamsFrom(url: string): string {
        return url.split('?')[0];
    }

    /**
     * Returns array of query params if set
     */
    private extractParamsFrom(url: string): string[] | undefined {
        let params;

        if (url.indexOf('?') > -1) {
            params = url.split('?')[1].split('&');
        }

        return params;
    }
}
